export const CLOUDFLARE_CUSTOMER_ID = '9fnkyzdtf61fdmmh';

export const CLOUDFLARE_STREAM_BASE_URL = `https://customer-${CLOUDFLARE_CUSTOMER_ID}.cloudflarestream.com`;

export const getSrcFromStreamId = (streamId: string, format: 'mpd' | 'm3u8') =>
    `${CLOUDFLARE_STREAM_BASE_URL}/${streamId}/manifest/video.${format}`;

export const getPosterFromStreamId = (streamId: string) =>
    `${CLOUDFLARE_STREAM_BASE_URL}/${streamId}/thumbnails/thumbnail.jpg?time=1s`;

export const rewriteMpdRelativeUrlsToAbsolute = (mpdXml: string, baseUrl: URL) => {
    const parser = new DOMParser();
    const xml = parser.parseFromString(mpdXml, 'application/xml');

    // These attributes are naturally using URLs relative to the manifest (src)
    // We need to resolve them to absolute URLs to ensure they do not cause issues in capacitor
    const attributesToFix = ['initialization', 'media'];

    attributesToFix.forEach(attr => {
        const nodes = xml.querySelectorAll(`[${attr}]`);
        nodes.forEach(node => {
            const value = node.getAttribute(attr);
            if (!value) return;
            try {
                // If it's a relative URL, resolve it
                if (!/^https?:\/\//.test(value)) {
                    const resolved = new URL(value, baseUrl).toString();

                    node.setAttribute(attr, resolved);
                }
            } catch (e) {
                throw new Error(`Attempt to patch MPD file response failed: ${e}`);
            }
        });
    });

    return new XMLSerializer().serializeToString(xml);
};
